import React from 'react';
import { LatestPriceDto } from '../../api';
import { formatMoney } from '../../util/formatMoney';

const MUTED = '#5f6b7a';

/**
 * Latest (extended-hours-aware) price for a single ticker, sourced from Polygon.
 * Polygon prices are USD and ~15 min delayed on the current plan; they include
 * pre/after-market trading. Shows … while loading, — when absent.
 */
export const LatestPriceCell: React.FC<{ dto?: LatestPriceDto | null; loading?: boolean }> = ({ dto, loading }) => {
    if (!dto || dto.price == null || Number.isNaN(dto.price)) {
        return <span style={{ color: MUTED }}>{loading && !dto ? '…' : '—'}</span>;
    }

    const parts = ['Polygon'];
    if (dto.asOf) {
        const asOf = new Date(dto.asOf);
        if (!Number.isNaN(asOf.getTime())) {
            parts.push(`as of ${asOf.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`);
        }
    }
    parts.push('~15 min delayed');
    if (dto.source) parts.push(dto.source);
    const title = parts.join(' · ');

    return <span title={title}>{formatMoney(dto.price, 'USD')}</span>;
};
